module.exports = __webpack_public_path__ + "img/hashtag-white.eb4acbc3.svg";